<script setup>
import { onClickOutside } from '@vueuse/core'

const props = defineProps({
  placeholder: {
    type: String,
    default: 'Selecciona una opción'
  },
  options: {
    type: Array,
    required: true
  }
})
const emit = defineEmits(['selected'])

const selected = defineModel()
const select = (promotion) => {
  selected.value = promotion
  dropdownOpen.value = false
  emit('selected', promotion)
}
const dropdownOpen = ref(false)
const toggleDropdown = () => {
  dropdownOpen.value = !dropdownOpen.value
}

const dropdownRef = ref(null)

onClickOutside(dropdownRef, () => {
  if (dropdownOpen.value) {
    dropdownOpen.value = false
  }
})

</script>

<template>
  <div ref="dropdownRef" class="relative">
    <button @click="toggleDropdown"
            class="flex items-center gap-3 p-3 bg-slate-50 rounded-md border border-slate-100 hover:border-primary/50 transition-colors text-left group w-full"
    >
      <div v-if="selected" class="flex-1 overflow-hidden">
        <slot name="selected" :selected="selected">
          <h2 class="text-sm font-bold text-slate-900 truncate">
            {{ selected.name }}
          </h2>
        </slot>
      </div>
      <div v-if="!selected" class="flex-1 overflow-hidden">
        <slot name="placeholder">
          <h2 class="text-sm font-bold text-slate-500 truncate">
            {{ props.placeholder }}
          </h2>
        </slot>
      </div>
      <Icon
          name="material-symbols:unfold-more"
          class="text-slate-400 text-[18px] transition-transform"
          :class="{ 'rotate-180': dropdownOpen }"
      />
    </button>

    <Transition name="dropdown">
      <div
          v-if="dropdownOpen"
          class="absolute top-full left-0 mt-1 min-w-full w-max max-w-[calc(100vw-2rem)] md:max-w-md bg-white rounded-md border border-slate-200 shadow-xl max-h-80 overflow-y-auto z-50"
      >
      <button
          v-for="option in props.options"
          :key="option.id"
          @click="select(option)"
          class="flex items-center gap-3 p-3 w-full hover:bg-slate-50 transition-colors border-b border-slate-100 last:border-b-0"
          :class="{ 'bg-primary/5': selected?.id === option.id }"
      >
        <div class="flex-1 overflow-hidden text-left">
          <slot name="option" :option="option">
          <h3 class="text-sm font-bold text-slate-900 truncate">
            {{ option.label }}
          </h3>
          </slot>
        </div>
        <Icon
            v-if="selected?.id === option.id"
            name="mdi:check-circle"
            class="text-primary text-[18px] flex-shrink-0"
        />
      </button>
    </div>
  </Transition>
  </div>

</template>